import kebabCase from 'lodash/kebabCase';
import * as React from 'react';
import type { CSSProperties, JSX } from 'react';

import { generateTestId } from '../../lib/test-helpers';
import { cn } from '../../v2';
import type { ButtonVariant } from '../button';
import { Button } from '../button';
import { IconCaret } from '../icons';
import type { MenuItem } from '../menu-2';
import { Menu } from '../menu-2';
import { Popper } from '../popper';

interface Props {
  items: MenuItem[];
  children: React.ReactNode;
  width?: number;
  variant?: ButtonVariant;
  style?: CSSProperties;
  testId?: string;
  buttonIconGap?: 'gap-1' | 'gap-2';
}

export function ButtonMenu2({
  children,
  variant = 'primary',
  items,
  width,
  style,
  testId: propTestId,
  buttonIconGap = 'gap-1',
}: Props): JSX.Element {
  const testId =
    propTestId ??
    (typeof children === 'string' ? generateTestId(kebabCase(children.toString()), 'button-menu') : undefined);

  return (
    <>
      <Popper
        // eslint-disable-next-line react/no-unstable-nested-components
        trigger={({ triggerRef, toggle }) => (
          <Button
            type="button"
            size={variant}
            elementRef={triggerRef}
            onClick={toggle}
            minWidth={width}
            style={style}
            testId={testId}
          >
            <div className={cn('flex flex-row items-center justify-center', buttonIconGap)}>
              {children}
              <IconCaret color="currentColor" />
            </div>
          </Button>
        )}
      >
        {({ toggle }) => <Menu items={items} onItemClick={toggle} />}
      </Popper>
    </>
  );
}
